import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {getDatesSummaryAndNightCountLabel, getNightsCountLabel} from '../../../utils/dates';

function useComponent(props) {
    const {
        datesTranslations: {
            nightsText
        },
        mediaSettings: {
            isMobile
        },
        latestDatesValues: {
            startDate,
            endDate
        },
        systemOptions: {
            locale
        }
    } = useSearchFormContext();

    let message = '';

    if (isMobile) {
        message = getNightsCountLabel(startDate, endDate, nightsText);
    } else {
        const {data} = props;
        const endDateValue = endDate || data && data.endDate;

        message = endDateValue ?
            getDatesSummaryAndNightCountLabel(startDate, endDateValue, locale, nightsText)
            : '';
    }

    const result = {
        message,
        isMobile
    };

    return result;
}

export {useComponent};